import { UserCheck, Plus, Clock } from "lucide-react";
import { fmtDate } from "@/lib/format";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { LeadSequencePanel } from "@/components/admin/LeadSequencePanel";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

function Quick({ onClick, label }) {
  return <button onClick={onClick} className="px-3 py-1.5 rounded-full bg-[#f0f2f8] text-[#1a2d56] text-xs font-semibold hover:bg-[#e2e8f0]">{label}</button>;
}

export function LeadActionsPanel({
  lead, meta, note, setNote, assignee, setAssignee, onSetStatus, onAddNote, onAssign, reload,
}) {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-2xl border border-[#e2e8f0] p-6">
        <h2 className="font-head font-bold text-[#1a2d56] mb-3">Statut commercial</h2>
        <Select value={lead.status} onValueChange={onSetStatus}>
          <SelectTrigger data-testid="status-select" className="rounded-xl"><SelectValue /></SelectTrigger>
          <SelectContent>
            {meta.statuses.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
          </SelectContent>
        </Select>
        <div className="flex flex-wrap gap-2 mt-3">
          <Quick onClick={() => onSetStatus("Contacté")} label="Contacté" />
          <Quick onClick={() => onSetStatus("Rendez-vous confirmé")} label="RDV pris" />
          <Quick onClick={() => onSetStatus("Inscrit")} label="Inscrit" />
          <Quick onClick={() => onSetStatus("Perdu")} label="Perdu" />
        </div>
        {lead.last_contact && <p className="text-xs text-[#9aa6c0] mt-3 flex items-center gap-1"><Clock size={12} /> Dernier contact : {fmtDate(lead.last_contact)}</p>}
      </div>

      <LeadSequencePanel lead={lead} reload={reload} />

      <div className="bg-white rounded-2xl border border-[#e2e8f0] p-6">
        <h2 className="font-head font-bold text-[#1a2d56] mb-3 flex items-center gap-2"><UserCheck size={16} /> Responsable</h2>
        <div className="flex gap-2">
          <Input data-testid="assignee-input" value={assignee} onChange={(e) => setAssignee(e.target.value)} placeholder="Nom du membre" className="rounded-xl" />
          <button onClick={onAssign} data-testid="assign-button" className="shrink-0 bg-[#1a2d56] text-white rounded-xl px-4 text-sm font-semibold">OK</button>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-[#e2e8f0] p-6">
        <h2 className="font-head font-bold text-[#1a2d56] mb-3">Notes internes</h2>
        <Textarea data-testid="note-input" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Ajouter une note…" className="rounded-xl min-h-[80px]" />
        <button onClick={onAddNote} data-testid="add-note-button" className="mt-2 w-full inline-flex items-center justify-center gap-2 bg-[#d7de3b] text-[#1a2d56] font-bold rounded-full py-2.5 text-sm">
          <Plus size={15} /> Ajouter la note
        </button>
        <div className="mt-4 space-y-3">
          {(lead.notes || []).slice().reverse().map((n) => (
            <div key={n.at} className="rounded-xl bg-[#f8f9fc] p-3">
              <p className="text-sm text-[#1a2d56]">{n.text}</p>
              <p className="text-xs text-[#9aa6c0] mt-1">{n.author} · {fmtDate(n.at)}</p>
            </div>
          ))}
          {(!lead.notes || lead.notes.length === 0) && <p className="text-sm text-[#9aa6c0]">Aucune note.</p>}
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-[#e2e8f0] p-6">
        <h2 className="font-head font-bold text-[#1a2d56] mb-3">Historique</h2>
        <div className="space-y-2">
          {(lead.history || []).slice().reverse().map((h) => (
            <div key={`${h.at}-${h.action}`} className="text-sm text-[#4b5b7c] flex gap-2">
              <span className="text-[#cbd5e1]">•</span>
              <span>{h.action} <span className="text-[#9aa6c0]">— {fmtDate(h.at)}</span></span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
